<template>
  <v-flex>
    <!-- DIALOG AGENCIES -->
    <!-- <v-dialog
      v-model="showAgencies"
      max-width="500px"
    >
      <v-card>
        <agencies-tree :from-section="fromSection" />
      </v-card>
    </v-dialog> -->
    <!-- BUBBLE NAME OFICIAL FENCES -->
    <div ref="infoBubbleOFRef">
      <info-bubble-polygon-name
        v-if="showOfficialFenceName"
        :info="infoOfficialFenceSelected"
        @closeBubble="showOfficialFenceName = false"
      />
    </div>
    <!-- POINT VIEWER -->
    <v-flex d-flex class="section-2 general-bg" ma-0 py-2>
      <!-- LEFT SIDE -->
      <v-flex class="section-1" px-4>
        <!-- TITLE -->
        <h3 v-if="!showResult" class="text-xs-left pt-2">Visualizador por Punto</h3>
        <!-- HEADER TEXT  -->
        <v-flex v-if="!showResult" py-3>
          Mueva el mapa usando como referencia el marcador <img :src="selectPointMarker" height="18px" alt="marker"> para elegir la posición a consultar o buscar un punto de interés <v-icon class="icon-search_text" small>search</v-icon>. También puede escribir la coordenada. Opcional pude elegir un <b>Radio</b> entre 0m y 500m
        </v-flex>
        <!-- SCROLL SECTION -->
        <v-flex
          v-if="!showResult"
          id="container-s-1"
          class="scroll-section"
          pa-2
        >
          <!-- INDICATORS & CONTROLS -->
          <v-flex px-1>
            <!-- POINT -->
            <v-flex d-flex align-center mt-3>
              <v-flex xs1 class="text-xs-center" pt-1>
                <img :src="selectPointMarker" height="32px" alt="marker">
              </v-flex>
              <v-flex xs11 pl-4>
                <v-flex>
                  <v-text-field
                    v-model="pointSelectedLat"
                    name="lat"
                    label="Lat"
                    color="white"
                    :rules="latRules"
                    type="number"
                    box
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="pointSelectedLng"
                    name="lng"
                    label="Lng"
                    color="white"
                    :rules="lngRules"
                    type="number"
                    box
                  ></v-text-field>
                </v-flex>
              </v-flex>
            </v-flex>
            <!-- SLIDER RADIUS -->
            <v-flex py-1 px-3 mt-3 class="radius-style">
              <v-flex d-inline-flex align-center class="height-1">
                <v-flex pr-1>
                  <b>Radio:</b>
                </v-flex>
                <v-text-field
                  v-model="radius"
                  class="radius-text ml-2"
                  type="number"
                >
                </v-text-field>
                <v-flex>
                  m
                </v-flex>
              </v-flex>
              <v-flex class="slider-style">
                <v-slider
                  v-model="radius"
                  :min="1"
                  :max="500"
                ></v-slider>
              </v-flex>
            </v-flex>
          </v-flex>
          <!-- SHOW AGENCIES -->
          <!-- <v-flex pa-1>
            <v-btn
              color="teal accent-3 grey--text text--darken-3"
              block
              @click="showAgencies = true"
            >
              <v-icon left>business</v-icon>
              Mostrar Agencias
            </v-btn>
            <v-flex 
              d-flex
              align-center
              v-if="agencySelected !== null"
              class="agency-section"
              py-1
              px-3
            >
              <v-flex d-inline-flex align-center>
                <v-flex xs2>
                  <v-icon>
                    business
                  </v-icon>
                </v-flex>
                <v-flex xs10>
                  {{ agencySelected.name }}
                </v-flex>
              </v-flex>
              <v-flex>
                <v-btn
                  fab
                  small
                  @click="agencySelectedAction(null)"
                >
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-flex>
            </v-flex>
          </v-flex> -->
          <!-- DATE & TIME -->
          <v-flex mt-3 px-1>
            <!-- DATE INTERVAL FOR DATE1 & DATE2 -->
            <v-flex>
              <v-menu
                lazy
                ref="menu"
                v-model="menu"
                transition="scale-transition"
                :close-on-content-click="false"
                :return-value.sync="dates"
                offset-y
                origin="top"
                color="white"
              >
                <template v-slot:activator="{ on }">
                  <v-combobox
                    v-model="dates"
                    multiple
                    chips
                    small-chips
                    label="Fecha"
                    placeholder="Escoger el día a consultar"
                    prepend-inner-icon="event"
                    readonly
                    box
                    color="white"
                    v-on="on"
                  >
                  </v-combobox>
                </template>
                <v-date-picker 
                  v-model="dates"
                  multiple
                  no-title
                  scrollable
                  :first-day-of-week="1"
                  locale="es-sp"
                  :allowed-dates="allowedDates"
                  color="blue accent-3"
                  @input="changesDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn color="error" @click="menu = false">Cancelar</v-btn>
                  <v-btn color="primary" @click="acceptDate1">Aceptar</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <!-- MENU TIME 1 DATE 1 -->
            <v-flex v-if="showInitialTime">
              <v-menu
                ref="time1Date1Menu"
                lazy
                :close-on-content-click="false"
                v-model="time1Date1Menu"
                transition="scale-transition"
                offset-x
                right
                full-width
                min-width="290px"
                origin="top left"
                :return-value.sync="time1Date1"
              >
                <v-text-field
                  slot="activator"
                  label="Hora Inicial"
                  placeholder="Seleccionar Hora"
                  v-model="time1Date1"
                  prepend-inner-icon="av_timer"
                  readonly
                  box
                  hide-details
                  color="white"
                />
                <v-time-picker 
                  v-model="time1Date1"
                  format="24hr"
                  scrollable
                  color="teal darken-1"
                  header-color="grey darken-4"
                  @input="changeTime1"
                >
                  <v-spacer></v-spacer>
                  <v-btn color="error" @click="time1Date1Menu = false">Cancelar</v-btn>
                  <v-btn color="primary" @click="acceptTime1">Aceptar</v-btn>
                </v-time-picker>
              </v-menu>
            </v-flex>
            <!-- TIME 2 DATE 1 MENU -->
            <v-flex v-if="showFinalTime" mt-3>
              <v-menu
                ref="time2Date1Menu"
                lazy
                :close-on-content-click="false"
                v-model="time2Date1Menu"
                transition="scale-transition"
                offset-x
                right
                full-width
                min-width="290px"
                origin="top left"
                :return-value.sync="time2Date1"
              >
              <v-text-field
                  slot="activator"
                  label="Hora Final"
                  placeholder="Seleccionar Hora"
                  v-model="time2Date1"
                  prepend-inner-icon="av_timer"
                  readonly
                  box
                  hide-details
                  color="white"
                />
                <v-time-picker 
                  v-model="time2Date1"
                  format="24hr"
                  scrollable
                  :allowed-hours="allowedHours"
                  :allowed-minutes="allowedMinutes"
                  color="red darken-1"
                  header-color="grey darken-4"
                  @click:hour="hourClicked"
                  @change="changeTime2"
                >
                  <v-spacer></v-spacer>
                  <v-btn color="error" @click="time2Date1Menu = false">Cancelar</v-btn>
                  <v-btn color="primary" @click="$refs.time2Date1Menu.save(time2Date1)">Aceptar</v-btn>
                </v-time-picker>
              </v-menu>
            </v-flex>
          </v-flex>

        </v-flex>
        <!-- BUTTON -->
        <v-flex v-if="!showResult">
          <!-- LOAD DATA -->
          <v-flex
            class="text-xs-center"
            my-2
          >
            <v-btn
              color="primary"
              :loading="$loading.isLoading('fetchingPointData')"
              :disabled="reportPointDisabled"
              block
              @click="fetchPointData"
            >
              <v-icon left>cloud</v-icon>
              Consultar Datos
            </v-btn>
          </v-flex>
          <!-- CLEAR FORM -->
          <v-flex
            v-if="showClearForm"
            class="text-xs-center"
          >
            <v-btn
              color="red"
              block
              @click="clearForm"
            >
              <v-icon left>clear</v-icon>
              Limpiar Datos
            </v-btn>
          </v-flex>
          

        </v-flex>
        <!-- ////////////////////////////////////////////// -->
        <!-- RESULT INFO -->
        <!-- ////////////////////////////////////////////// -->
        <transition-group tag="div" name="slide-fade">
          <v-flex key='resultData1' v-if="showResult">
            <v-flex pa-1>
              <v-btn
                color="primary"
                block
                @click="backToNewData"
              >
                <v-icon left>arrow_back</v-icon>
                Realizar Nueva Busqueda
              </v-btn>
            </v-flex>
            <!-- NO DATA -->
            <v-flex v-if="viewPointData.length === 0">
              No se encontraron datos
            </v-flex>
            <!-- WITH DATA -->
            <v-flex v-else>
              <!-- INFO DATA -->
              <v-flex>
                <!-- POINT -->
                <v-flex d-inline-flex my-2>
                  <v-flex pt-1 pl-3>
                    <img :src="selectPointMarker" height="32px" alt="marker">
                  </v-flex>
                  <v-flex pl-2>
                    <v-flex>
                      {{ `Lat: ${this.centerSet.lat}`}}
                    </v-flex>
                    <v-flex>
                      {{ `Lng: ${this.centerSet.lng}`}}
                    </v-flex>
                  </v-flex>
                </v-flex>
                <!-- DATE & TIME -->
                <v-flex d-inline-flex my-2 pl-3 align-center>
                  <v-flex>
                    <v-icon>
                      event
                    </v-icon>
                  </v-flex>
                  <v-flex class="caption" pl-2>
                    {{ date1 | filterFullDate }}
                  </v-flex>
                  <v-flex>
                    <v-icon>
                      arrow_right_alt
                    </v-icon>
                  </v-flex>
                  <v-flex class="caption">
                    {{ date2 | filterFullDate }}
                  </v-flex>
                </v-flex>
              </v-flex>
              <!-- AMOUNT OF VEHICLES -->
              <v-flex d-inline-flex my-2 pl-3>
                <v-flex>
                  <!-- {{ `${viewPointData.length === 1 ? 'Se encontro' : 'Se encontraron'}: ` }} -->
                  <v-icon>
                    directions_car
                  </v-icon>
                </v-flex>
                <v-flex pl-2>
                  {{ `${viewPointData.length} ${viewPointData.length === 1 ? 'Vehículo' : 'Vehículos'}` }}
                </v-flex>
                <v-flex>
                  {{ }}
                </v-flex>
              </v-flex>
              <!-- LIST -->
              <v-flex
                v-if="!pathsLoaded"
                id="container-s-2" 
                class="list-style" 
                mt-3
              >
                <v-list two-line>
                  <template v-for="(vehicle, index) in viewPointData">
                    <v-list-tile
                      :key="`${vehicle.id}-${index}`"
                      avatar
                      ripple
                      @click="toggle(index)"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title class="font-weight-bold">
                          {{ `${vehicle.code} | ${vehicle.licensePlate}` }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">
                          {{ vehicle.nearestPosition.time | filterFullDate }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-list-tile-action-text class="font-weight-bold">
                          {{ `${vehicle.nearestPosition.distance}m` }}
                        </v-list-tile-action-text>
                        <v-flex pt-1>
                          <v-icon
                            v-if="selected.indexOf(index) < 0"
                            color="grey lighten-1"
                          >
                            location_disabled
                          </v-icon>

                          <v-icon
                            v-else
                            color="primary"
                          >
                            gps_fixed
                          </v-icon>
                        </v-flex>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < viewPointData.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list>
              </v-flex>
              <v-flex v-else pt-5>
                <v-btn
                  color="primary"
                  block
                  @click="clearPaths"
                >
                  <v-icon left>view_list</v-icon>
                  Modificar Vehículo
                </v-btn>
              </v-flex>
            </v-flex>
          </v-flex>
        </transition-group>
      </v-flex>
      <!-- RIGHT SIDE -->
      <v-flex ml-3 my-2 pr-3>
        <v-flex class="official-zones">
          <!-- OFFICIAL FENCES -->
          <official-zones />
        </v-flex>
        <!-- SEARCH ARDDRESS -->
        <place-searcher
          v-if="!consultingData"
          class="place-searcher"
          parentComp="viewer-by-point"
          :map="mapRef"
          @toMap="placeToMap"
          @initSearchPlace="initSearchPlace"
          @outOfCenter="showResultSearchPlace = false"
        />
        <!-- OVER MAP -->
        <transition-group tag="div" name="slide-fade">
          <v-flex
            key="over-map-1"
            v-if="vehiclesSelected.length > 0"
            class="data-over-map"
          >
            <v-card width="220" color="grey darken-4">
              <v-flex class="text-xs-center body-2" pa-2>
                Vehículos Seleccionados
              </v-flex>
              <v-flex
                v-for="(item, index) in vehiclesSelected"
                :key="index"
                pa-2
                d-flex
                align-center
              >
                <v-flex>
                  <v-flex 
                    class="font-weight-bold"
                  >
                    {{ `${item.code} | ${item.licensePlate}` }}
                  </v-flex>
                  <v-flex 
                    class="caption text--primary"
                  >
                    {{ item.nearestPosition.time | filterFullDate }}
                  </v-flex>
                </v-flex>
                <v-flex class="text-xs-right">
                  <v-flex>
                    {{ `${item.nearestPosition.distance}m` }}
                  </v-flex>
                  <v-flex>
                    <v-icon
                      class="pl-1"
                      small
                      :color="colorsSelection.get(index)"
                    >
                      lens
                    </v-icon>
                  </v-flex>
                </v-flex>
              </v-flex>
              <v-flex pa-2>
                <v-btn
                  color="primary"
                  block
                  :loading="$loading.isLoading('filterPositionsByVehicleId')"
                  :disabled="pathsLoaded"
                  @click="fetchPaths"
                >
                  <v-icon left>find_replace</v-icon>
                    Cargar Recorridos
                </v-btn>
              </v-flex>
            </v-card>
          </v-flex>
        </transition-group>
        <!-- MAP -->
        <gmap-map
          class="map-style mb-1"
          :center="center"
          :zoom="zoom"
          ref="viewPointsMap"
          @center_changed="changes"
          :options="mapOptions"
        >
          <gmap-polyline
            v-for="(events0, index) in eventsBlocks0"
            :key="`${events0.id}-${index}`"
            :ref="'polyLine0'+index"
            :path="events0"
            :options="polylineOptions[0]"
          />
          <gmap-polyline
            v-for="(events1, index) in eventsBlocks1"
            :key="`${events1.id}-${index}`"
            :ref="'polyLine1'+index"
            :path="events1"
            :options="polylineOptions[1]"
          />
          <gmap-polyline
            v-for="(events2, index) in eventsBlocks2"
            :key="`${events2.id}-${index}`"
            :ref="'polyLine2'+index"
            :path="events2"
            :options="polylineOptions[2]"
          />
          <gmap-polyline
            v-for="(events3, index) in eventsBlocks3"
            :key="`${events3.id}-${index}`"
            :ref="'polyLine3'+index"
            :path="events3"
            :options="polylineOptions[3]"
          />
          <gmap-polyline
            v-for="(events4, index) in eventsBlocks4"
            :key="`${events4.id}-${index}`"
            :ref="'polyLine4'+index"
            :path="events4"
            :options="polylineOptions[4]"
          />
          <gmap-marker
            v-if="!showResult"
            :animation="2"
            :position="newCenter"
            :icon="selectPointMarker"
          ></gmap-marker>
          <gmap-circle
            v-if="!showResult"
            :center="newCenter"
            :radius="radius"
            :options="circleOptions"
          ></gmap-circle>
          <gmap-marker
            v-if="showResult"
            :animation="2"
            :position="centerSet"
            :icon="selectPointMarker"
          ></gmap-marker>
          <gmap-circle
            v-if="showResult"
            :center="centerSet"
            :radius="radius"
            :options="circleOptions"
          ></gmap-circle>
          <!-- OFFICIAL ZONES -->
          <gmap-polygon
            v-for="(path, index) in neighborhoodsPath"
            :key="`${index}N`"
            :paths="path"
            :options="polygonOptions1"
            @click="showPolygonName($event, {index, key: 'neighborhoods'})"
          />
          <gmap-polygon
            v-for="(path, index) in communesPath"
            :key="`${index}C`"
            :paths="path"
            :options="polygonOptions2"
            @click="showPolygonName($event, {index, key: 'communes'})"
          />

          <gmap-polygon
            v-for="(path, index) in quadrantsPath"
            :key="`${index}Q`"
            :paths="path"
            :options="polygonOptions3"
            @click="showPolygonName($event, {index, key: 'quadrants'})"
          />

          <gmap-polygon
            v-for="(path, index) in stationsPath"
            :key="`${index}S`"
            :paths="path"
            :options="polygonOptions4"
            @click="showPolygonName($event, {index, key: 'stations'})"
          />

          <gmap-polygon
            v-for="(path, index) in empasPath"
            :key="`${index}E`"
            :paths="path"
            :options="polygonOptions7"
            @click="showPolygonName($event, {index, key: 'empas'})"
          />

          <gmap-polygon
            v-for="(path, index) in districtsPath"
            :key="`${index}D`"
            :paths="path"
            :options="polygonOptions5"
            @click="showPolygonName($event, {index, key: 'districts'})"
          />

          <gmap-polygon
            v-for="(path, index) in firefightersPath"
            :key="`${index}F`"
            :paths="path"
            :options="polygonOptions6"
            @click="showPolygonName($event, {index, key: 'firefighters'})"
          />
        </gmap-map>
      </v-flex>
    </v-flex>
  </v-flex>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import mapOptions from '../../utils/mapOptions.js'
  import {SELECT_POINT_MARKER} from '../../utils/staticsRef'

  import AgenciesTree from '../AgenciesTree'
  import PlaceSearcher from '../PlaceSearcher'
  import OfficialZones from '../OfficialZones'
  import InfoBubblePolygonName from '../InfoBubblePolygonName'

  import { placeSearcherMixin } from '../../mixins/placeSearcherMixin'
  import { officialZonesMixin } from '../../mixins/officialZonesMixin'

  const colorsSelection = new Map([
    [0, 'purple'],
    [1, 'amber'],
    [2, 'light-green'],
    [3, 'cyan'],
    [4, 'deep-purple']
  ])

  export default {
    name: 'viewer-by-point',
    components: {
      AgenciesTree,
      PlaceSearcher,
      OfficialZones,
      InfoBubblePolygonName
    },
    mixins: [placeSearcherMixin, officialZonesMixin],
    data() {
      return {
        showClearForm: false,
        pathsLoaded: false,
        polylineOptions: [
          {
            strokeColor: '#9C27B0',
            strokeOpacity: 0.8,
            strokeWeight: 3,
            geodesic: true,
            icons: [{
              icon: {
                path: 1,
                scale: 2,
                fillColor: '#9C27B0'
              },
              offset: '0',
              repeat: '100px'
            }]
          },
          {
            strokeColor: '#FFC107',
            strokeOpacity: 0.8,
            strokeWeight: 3,
            geodesic: true,
            icons: [{
              icon: {
                path: 1,
                scale: 2,
                fillColor: '#FFC107'
              },
              offset: '0',
              repeat: '100px'
            }]
          },
          {
            strokeColor: '#8BC34A',
            strokeOpacity: 0.8,
            strokeWeight: 3,
            geodesic: true,
            icons: [{
              icon: {
                path: 1,
                scale: 2,
                fillColor: '#8BC34A'
              },
              offset: '0',
              repeat: '100px'
            }]
          },
          {
            strokeColor: '#00BCD4',
            strokeOpacity: 0.8,
            strokeWeight: 3,
            geodesic: true,
            icons: [{
              icon: {
                path: 1,
                scale: 2,
                fillColor: '#00BCD4'
              },
              offset: '0',
              repeat: '100px'
            }]
          },
          {
            strokeColor: '#673AB7',
            strokeOpacity: 0.8,
            strokeWeight: 3,
            geodesic: true,
            icons: [{
              icon: {
                path: 1,
                scale: 2,
                fillColor: '#673AB7'
              },
              offset: '0',
              repeat: '100px'
            }]
          }
        ],
        eventsBlocks0: [],
        eventsBlocks1: [],
        eventsBlocks2: [],
        eventsBlocks3: [],
        eventsBlocks4: [],
        centerSet: {},
        colorsSelection,
        selected: [],
        vehiclesSelected: [],
        // showAgencies: false,
        fromSection: 'view-point',
        latRules: [
          v => !!v || 'Latitud Requerida'
        ],
        lngRules: [
          v => !!v || 'Longitud Requerida'
        ],
        showInitialTime: false,
        showFinalTime: false,
        urlReportPoint: '',
        onlyDate1: null,
        onlyDate2: null,
        date1: null,
        date2: null,
        limitTime: null,
        limitHour: null,
        limitMinute: null,
        time1Date1Menu: false,
        time1Date1: null,
        time2Date1Menu: false,
        time2Date1: null,
        dates: [],
        menu: false,
        radius: 500,
        circleOptions: {
          strokeColor: '#1E88E5',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#2196F3',
          fillOpacity: 0.35
        },
        center: {
          lat: 6.254790211409118,
          lng: -75.551029793457
        },
        newCenter: {
          lat: 6.254790211409118,
          lng: -75.551029793457
        },
        zoom: 13,
        mapOptions,
        selectPointMarker: SELECT_POINT_MARKER,
        mapRef: null,
        consultingData: false
      }
    },
    watch: {
      showResult(newValue) {
        if (!newValue) {
          this.centerSet = {}
          this.zoom = 13
        } else {
          this.center = {
            lat: this.centerSet.lat,
            lng: this.centerSet.lng
          }
          if (this.radius > 350) this.zoom = 16
          else this.zoom = 17
        }
      }
    },
    computed: {
      ...mapGetters([
        'showResult',
        'viewPointData',
        'agencySelected'
      ]),
      pointSelectedLat: {
        get() {
          return this.newCenter.lat
        },
        set(value) {
          this.newCenter.lat = Number(value)
          this.center.lat = Number(value)
        }
      },
      pointSelectedLng: {
        get() {
          return this.newCenter.lng
        },
        set(value) {
          this.newCenter.lng = Number(value)
          this.center.lng = Number(value)
        }
      },
      reportPointDisabled() {
        let result = true
        if (this.dates.length === 1 && this.time1Date1 && this.time2Date1) result = false
        return result
      }
    },
    methods: {
      ...mapActions([
        'agencySelectedAction',
        'fetchPathsViewerByPoint',
        'showResultAction',
        'getPointData',
        'showMap',
        'addInitPosition'
      ]),
      clearForm() {
        this.showInitialTime = false
        this.showFinalTime = false
        this.dates = []
        this.showClearForm = false
        this.date1 = null
        this.date2 = null
        this.time1Date1 = null
        this.time2Date1 = null
        this.radius = 500
      },
      clearPaths() {
        this.pathsLoaded = false
        this.eventsBlocks0 = []
        this.eventsBlocks1 = []
        this.eventsBlocks2 = []
        this.eventsBlocks3 = []
        this.eventsBlocks4 = []
        this.selected = []
        this.vehiclesSelected = []
        this.zoom = 15
      },
      async fetchPaths() {
        // console.log('LOAD PATHS')
        const date1Split = this.date1.split(' ')
        const date2Split = this.date2.split(' ')

        const vehiclesId = []
        this.vehiclesSelected.forEach(vehicle => {
          vehiclesId.push(vehicle.id)
        })

        const time1 = date1Split[1].split(':')
        const time2 = date2Split[1].split(':')

        const payload = {
          date1: date1Split[0],
          date2: date2Split[0],
          time1Date1: `${time1[0]}:${time1[1]}`,
          time2Date1: `${time2[0]}:${time2[1]}`,
          vehiclesId
        }
        // console.log('PAYLOAD', payload)
        const resultArray = await this.fetchPathsViewerByPoint(payload)
        // console.log('RESULT ARRAY IN', resultArray)

        if (resultArray.length > 0) {
          this.pathsLoaded = true
          for (let index = 0; index < resultArray.length; index++) {
            const element = resultArray[index]
            // console.log('ELEMENT', element)
            // console.log('ELEMENT DATA DATA', element.data.data)
            this[`eventsBlocks${String(index)}`].push(element.data.data)
            // console.log('eventsBlocks', index, this[`eventsBlocks${String(index)}`])
          }
          this.zoom = 14
        } else this.pathsLoaded = false
      },
      backToNewData() {
        this.consultingData = false
        this.showClearForm = true
        this.pathsLoaded = false
        this.eventsBlocks0 = []
        this.eventsBlocks1 = []
        this.eventsBlocks2 = []
        this.eventsBlocks3 = []
        this.eventsBlocks4 = []
        this.selected = []
        this.vehiclesSelected = []
        this.showResultAction(false)
        this.zoom = 13
      },
      toggle(index) {
        if (this.vehiclesSelected.length < 5) {
          const i = this.selected.indexOf(index)
  
          if (i > -1) {
            this.selected.splice(i, 1)
            this.vehiclesSelected.splice(i, 1)
          } else {
            this.selected.push(index)
            this.vehiclesSelected.push(this.viewPointData[index])
          }
        } else {
          const i = this.selected.indexOf(index)

          if (i > -1) {
            this.selected.splice(i, 1)
            this.vehiclesSelected.splice(i, 1)
          }
        }
        // console.log(this.vehiclesSelected)
      },
      clearVehicles() {
        this.vehiclesSelected = []
      },
      displayVehicles() {
        console.log('DISPLAY VEHICLES')
      },
      changeTime2() {
        // console.log('CHANGE TIME 2', this.time1Date1, this.time2Date1)
        // const startTime = this.$moment(this.time1Date1, 'HH:mm')
        // const finalTime = this.$moment(this.time2Date1, 'HH:mm')
        // console.log('startTime: ', startTime)
        // console.log('finalTime: ', finalTime)
        // const differenceTime = this.$moment(startTime).diff(finalTime, 'hours')
        // console.log('DIFF: ', differenceTime)
      },
      acceptDate1() {
        this.$refs.menu.save(this.dates)
        this.time1Date1 = '00:00'
        this.showInitialTime = true
      },
      acceptTime1() {
        this.$refs.time1Date1Menu.save(this.time1Date1)
        this.time2Date1 = this.time1Date1
        this.showFinalTime = true
      },
      hourClicked(value) {
        // console.log('HOUR CLICKED', value)
      },
      fetchPointData() {
        this.consultingData = true
        const agencies = []
        // console.log(this.agencySelected)
        if (this.agencySelected !== null) agencies.push(this.agencySelected.agencyId)

        const payload = {
          date1: this.date1,
          date2: this.date2,
          lat: this.newCenter.lat,
          lng: this.newCenter.lng,
          radius: this.radius,
          agencies
        }
        // console.log('DOWNLOAD POINT REPORT: ', payload)
        this.centerSet = this.newCenter
        this.getPointData(payload)
      },
      changes(event) {
        if (!this.showResult) {
          this.newCenter.lat = event.lat()
          this.newCenter.lng = event.lng()
        }
      },
      changesDate() {
        // console.log('CHANGE DATE')
        if (this.dates.length === 0) {
          this.showInitialTime = false
          this.showFinalTime = false
          this.onlyDate1 = null
          this.onlyDate2 = null
          this.date1 = null
          this.date2 = null
          this.limitTime = null
          this.limitHour = null
          this.limitMinute = null
          this.time1Date1Menu = false
          this.time1Date1 = null
          this.time2Date1Menu = false
          this.time2Date1 = null
        }
      },
      changeTime1() {
        // console.log('CHANGE TIME 1')
        this.time2Date1 = null
      },
      allowedMinutes(value) {
        // console.log('allowedMinutes', value, this.time2Date1)
        if (this.time2Date1 !== null) {
          const selectedHour = this.time2Date1.split(':')
          // console.log('selectedHour: ', Number(selectedHour[0]), Number(this.limitHour))
          if (Number(selectedHour[0]) === Number(this.limitHour)) {
            // console.log('********* ', value, this.limitMinute)
            if (value <= this.limitMinute) return true
            else return false
          }
        }
        return true
      },
      allowedHours(value) {
        // console.log('allowedHours', value, this.time1Date1)
        const myDate = `${this.dates[0]} ${this.time1Date1}`
        this.date1 = this.$moment(myDate).format('YYYY-MM-DD HH:mm:ss')

        if (this.time2Date1) {
          const selectedHour1 = this.time1Date1.split(':')
          const selectedHour2 = this.time2Date1.split(':')
          let myDate2 = null
          // console.log('selectedHour2 time2Date1', Number(selectedHour2[0]), this.onlyDate1, this.onlyDate2)
          // console.log(this.onlyDate1 !== this.onlyDate2)
          // console.log(Number(selectedHour2[0]) < Number(selectedHour1[0]))

          if (Number(selectedHour2[0]) < Number(selectedHour1[0]) && this.onlyDate1 !== this.onlyDate2) myDate2 = `${this.onlyDate2} ${this.time2Date1}`
          else myDate2 = `${this.dates[0]} ${this.time2Date1}`

          // console.log('MY DATE 2: ', myDate2)

          this.date2 = this.$moment(myDate2).format('YYYY-MM-DD HH:mm:ss')
          // console.log('DATE 2: ', this.date2)
        }
        // console.log('MY DATE: ', myDate)
        const selectedHour = this.$moment(myDate).format('H')
        // console.log('selectedHour', selectedHour)
        const oneAfter = this.$moment(myDate).add(1, 'hours').format('H')
        this.limitTime = this.$moment(myDate).add(2, 'hours').format('YYYY-MM-DD HH:mm:ss')
        this.onlyDate1 = this.$moment(myDate).format('YYYY-MM-DD')
        this.onlyDate2 = this.$moment(myDate).add(2, 'hours').format('YYYY-MM-DD')
        // console.log('ONLY DATE 2: ', this.onlyDate2)
        this.limitHour = this.$moment(this.limitTime).format('H')
        this.limitMinute = this.$moment(this.limitTime).format('mm')
        // console.log('oneAfter: ', oneAfter)
        // console.log('limitTime: ', this.limitTime)
        // console.log('limitHour: ', this.limitHour)
        // console.log('limitMinute: ', this.limitMinute)
        if (value === Number(selectedHour) || value === Number(oneAfter) || value === Number(this.limitHour)) {
          // console.log('VALUE: ', value)
          return true
        } else return false
      },
      allowedDates(date) {
        let today = this.$moment.now()
        let datesResult = this.$moment(date).isBefore(today)
        today = this.$moment(today).format('YYYY-MM-DD')

        if (this.dates.length === 1) datesResult = date === this.dates[0]

        return datesResult
      }
    },
    created() {
      this.mapOptions.scrollwheel = false
      this.showResultAction(false)
    },
    mounted() {
      this.$refs.viewPointsMap.$mapPromise.then((map) => {
        setTimeout(() => {
          this.mapRef = map
        }, 2000)
        map.addListener('zoom_changed', () => {
          this.showOfficialFenceName = false
        })
        map.addListener('drag', () => {
          this.showOfficialFenceName = false
        })
      })
    },
    activated() {
      this.mapOptions.scrollwheel = false
      this.showResultAction(false)
    },
    deactivated() {
      this.mapOptions.scrollwheel = true
      this.showResultAction(false)
    }
  }
 </script>
 
 <style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500

h4
  font-size 21px
  font-weight 500

b
  color #BDBDBD

.agency-section
  background-color #424242
  border-radius 3px

.data-over-map
  position: absolute;
  top: 205px;
  left: 440px;
  z-index: 5;

.list-style
  height calc(100vh - 450px)
  overflow auto
  // background-color #303030
  // border-radius 2px


#container-s-1::-webkit-scrollbar-track,
#container-s-2::-webkit-scrollbar-track
{
  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
  background-color: #303030;
}

#container-s-1::-webkit-scrollbar,
#container-s-2::-webkit-scrollbar
{
  width: 10px;
  background-color: #303030;
}

#container-s-1::-webkit-scrollbar-thumb,
#container-s-2::-webkit-scrollbar-thumb
{
  border-radius: 10px;
  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #616161;
}

.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-enter {
  transform: translateX(30px);
  opacity: 0;
}

.scroll-section
  background-color #303030
  border-radius 2px
  // min-height 400px
  height calc(100vh - 490px)
  overflow auto

.height-1
  height 50px

.radius-style
  background-color #424242
  border-radius 2px
  height 80px

.radius-text
  min-width 40px
  max-width 40px

.slider-style
  margin-top -25px

.map-style
  width: 100%
  min-height: 100%

.section-1
  min-width 390px
  max-width 390px

.section-2
  width 100%
  height calc(100vh - 200px)
  margin-left 10px
  margin-right 10px

.general-bg
  background-color #424242
  border-radius 3px

.place-searcher {
  position: absolute;
  top: 135px;
  left: 433px;
  z-index: 5;
}

.icon-search_text {
  background-color: #212121;
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.official-zones {
  position: absolute;
  top: 20px;
  right: 25px;
  z-index: 5;
}
 </style>


// WEBPACK FOOTER //
// src/components/Viewers/ViewerByPoint.vue